<template>
  <div
    class="w-full flex flex-col lg:flex-row items-start justify-start gap-6 lg:gap-10 px-4 lg:px-48"
  >
    <div
      class="bg-white rounded-xl shadow-md flex flex-col items-start text-gray-800 w-full"
    >
      <p
        class="px-6 py-2 font-medium text-base text-white lg:text-lg bg-primary w-full mt-5 lg:mt-10"
      >
        Photo and Video Consent
      </p>

      <div class="p-3 lg:p-6 w-full">
        <p class="mt-1 lg:mt-3 text-gray-600">
          By participating in the fun run, you grant PAFCPIC permission to use your
          photos and videos for promotional purposes.
        </p>

        <div
          class="flex flex-row space-x-2 text-sm lg:text-base mt-4 items-center text-gray-600"
        >
          <input
            type="checkbox"
            id="agree"
            v-model="isAgreed"
            @change="saveConsent"
            class="cursor-pointer w-4 h-4" style="accent-color: #016B00;"
          />
          <label for="agree" class="cursor-pointer select-none">
            I grant my permission to PAFCPIC
          </label>
        </div>

        <div class="w-full flex justify-end mt-10">
          <div class="w-full flex flex-row lg:w-1/3 space-x-3">
            <ButtonControl
              ref="proceed"
              variant="secondary"
              @click="$router.back()"
            >
              BACK
            </ButtonControl>

            <!-- ✅ Disabled until checkbox is checked -->
            <ButtonControl
              ref="proceed"
              variant="primary"
              :disabled="!isAgreed"
              @click="$router.push('/confirm')"
            >
              NEXT
            </ButtonControl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonControl from "@/components/controls/ButtonControl.vue";
import confirmLeave from "@/mixins/confirmLeave";

export default {
  name: "ConsentView",
  mixins: [confirmLeave],
  components: {
    ButtonControl,
  },
  data() {
    return {
      isAgreed: false,
    };
  },
  mounted() {
    // ✅ Auto-fill from store if value exists
    if (this.$store.state.consent !== undefined) {
      this.isAgreed = this.$store.state.consent;
    }

    if (!this.$store.state.form) {
            this.$router.push('/')
        }
  },
  methods: {
    saveConsent() {
      // ✅ Save to Vuex store whenever checkbox changes
      this.$store.state.consent = this.isAgreed;
    },
  },
};
</script>

<style scoped></style>
